import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, share, switchMap } from 'rxjs';
import { MfaService } from '../../services/mfa.service';
import { MfaActions } from '@states/mfa/mfa.action-types';

@Injectable()
export class MfaEffects {
  public getUserMfaMethods$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MfaActions.getUserMfaMethods),
      switchMap(() => {
        return this.mfaService
          .getAll()
          .pipe(
            switchMap(res => {
              return [
                MfaActions.getUserMfaMethodsSuccess({ documents: res.list }),
              ];
            }),
            catchError(() => {
              return [
                MfaActions.getUserMfaMethodsFail(),
              ];
            }),
            share(),
          );
      }),
    ),
  );

  constructor(private actions$: Actions, private mfaService: MfaService) {}
}
